module.exports = __webpack_public_path__ + "2ed97b26362169eedfc41a62d7b91e31.png";